import clsx from 'clsx'
import map from 'lodash/map'
import React, { FC, ReactNode } from 'react'

import styles from './TabButtons.module.scss'

export interface Tab {
  icon: ReactNode
  key: string
  title: string
}

interface TabButtonsProps<T extends Tab> {
  activeKey: string | null
  className?: string
  onClick: (tab: T) => void
  tabs: T[]
}

export const TabButtons: FC<TabButtonsProps<any>> = ({ activeKey, className, onClick, tabs }) => (
  <span className={clsx(className, styles.tabButtons)}>
    {map(tabs, item => (
      <button key={item.key} className={clsx(styles.tabButton, activeKey === item.key && styles.active)} onClick={() => onClick(item)} type="button">
        {item.icon}
        {item.title}
      </button>
    ))}
  </span>
)
